import { Setor } from './../../setor/setor.model';
import { CanalModel } from "../../canal/canal-model";
import { DisparoAutomaticoModel } from "../../disparo-automatico/disparo-automatico.model";
import { FluxoSelect } from "../../fluxo/fluxo-select-model";
import { TemplateModel } from "../../template/template-model";
import { Usuario } from "../../usuario/usuario.model";

export class MensagemDetalhesModel {
  numeroEnvio?: string;
  template?: TemplateModel;
  disparo?: DisparoAutomaticoModel;
  fluxo?: FluxoSelect;
  canal?: CanalModel;
  operador?: Usuario;
  setor?: Setor;
}
